import { render, staticRenderFns } from "./reminderReceiver.vue?vue&type=template&id=a45feecc&scoped=true&"
import script from "./reminderReceiver.vue?vue&type=script&lang=ts&"
export * from "./reminderReceiver.vue?vue&type=script&lang=ts&"
import style0 from "./reminderReceiver.vue?vue&type=style&index=0&id=a45feecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45feecc",
  null
  
)

export default component.exports